import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { DashboardServicesModule } from '@app/features/dashboard/services/dashboard-services.module';

import { State as StpState } from '@app/stp/state/reducers';

import { selectPolicyDetails } from '@app/stp/state/selectors';

import { ERRORS_LOAD_POLICY_FAILED } from '@app/infrastructure/constants';

@Injectable({
  providedIn: DashboardServicesModule
})
export class DashboardActivateGuard implements CanActivate {

  constructor(
    private router: Router,
    private store: Store<StpState>
  ) { }

  checkForPolicy() {
    return this.store.pipe(
      select(selectPolicyDetails),
      concatMap(data => {
        if (!data) {
          this.router.navigate([ERRORS_LOAD_POLICY_FAILED]);
        }
        return of(true);
      })
    );
  }

  canActivate(): boolean | any {
    return this.checkForPolicy().pipe(map(policy => policy));
  }
}
